export default {
      id: "part-usage",
      viewBox: "0 0 70 53",
      url: "assets/" + "sprite.svg#part-usage",
      toString: function () {
        return this.url;
      }
    }